module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_bg.27a0f63a.png";